import {patchState, signalStore, withMethods, withState} from "@ngrx/signals";
import {HttpClient} from "@angular/common/http";
import {inject, Type} from "@angular/core";
import {authStore} from "../../core/service/auth/auth.store";

type CompanyListingStoreState = {
    companies: unknown[]
}

export type CompanyListingStore = Type<typeof companyListingStore>
export const companyListingStore = signalStore(
    {providedIn: 'root'},

    withState<CompanyListingStoreState>({
        companies: []
    }),

    withMethods((store, http = inject(HttpClient), auth = inject(authStore))=>({
        setCompanies(companies: any[]) {
            patchState(store, {companies});
        },
        fetchCompanies() {
            http.get<any>("/api/company").subscribe(this.setCompanies)
        },
        provideCompanies() {
            if(store.companies().length<1 && auth.hasAuthority("ROLE_EMPLOYEE")()){ this.fetchCompanies(); }
            return store.companies;
        },
        reset() {
            patchState(store,{companies: []});
        }
    }))

)